import mainActions from './mainActions';
import appActions from './appActions'

export const main = mainActions;
export const app = appActions;